<template>
<div>
    <h1 class="display-heading">Dashboard</h1>

    <div class="row">
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Video Consultations</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalVideoConsultation" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalConsultations">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{paidConsultations.count}}</span>
                            <span class="ml-3">Video Consultation<span v-if="paidConsultations.count>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Purchase of Medicines (Pharmacy)</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalPurchasedMedicine" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalPurchasedMedicine">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{paidPrescriptions.count}}</span>
                            <span class="ml-3">Purchase<span v-if="paidPrescriptions.count>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card mb-4">
        <div class="card-body">
            <h5 class="mb-3">Upcoming Appointments</h5>
            <div class="d-md-none">
                <div class="card mb-3" v-for="(appointment, index) in upcomingAppointments" :key="index">
                    <div class="card-body">
                        <div class="mb-3">
                            <label class="label-display">
                                Date
                            </label>
                            <div>
                                 {{appointment.startDate}}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Time
                            </label>
                            <div>
                                 {{appointment.startTime}}
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="label-display">
                                Status
                            </label>
                            <div class="mt-2">
                                <span class="badge text-nowrap" :class="getAppointmentStatusBadgeClass(appointment.status)">
                                    {{getAppointmentStatus(appointment.status)}}
                                </span>
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="label-display">
                                Doctor Name
                            </label>
                            <div>
                                 {{appointment.targetUser}}
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="label-display">
                                Medical Reports Viewable by Doctor?
                            </label>
                            <div>
                                 {{appointment.consentViewMedicalReport}}
                            </div>
                        </div>

                        <div>
                            <label class="label-display">
                                Action
                            </label>
                            <div class="mt-2">
                                <template v-if="appointment.status === 0">
                                    <a class="btn btn-danger" href="javascript:void(0);" @click="showCancelConfirmation(appointment.appointmentId)">
                                        Cancel Appointment
                                    </a>
                                </template>
                                <template v-else-if="appointment.status === 998">
                                    <router-link class="btn btn-primary btn-primary-insv mr-2 mb-2" :to="{'name': 'user-doctor-appointment-detail', 'params': {'id': appointment.appointmentId}}">
                                        Pay Now
                                    </router-link>
                                    <a class="btn btn-danger mb-2" href="javascript:void(0);" @click="showCancelConfirmation(appointment.appointmentId)">Cancel Appointment</a>
                                </template>
                                <template v-else-if="appointment.status === 1000">
                                    <a href="javascript:void(0);"  class="btn btn-primary btn-primary-insv mr-2 mb-2" @click="patientStartConsultation(appointment.sessionId)">Start Tele-Video</a>
                                    <template v-if="appointment.isWithin24Hours">
                                     <a class="btn btn-danger mb-2" href="javascript:void(0);" @click="showCancelConfirmation(appointment.appointmentId)">Cancel Appointment</a>
                                    </template>
                                </template>
                                <template v-else>
                                    <span class="font-italic">
                                    No Action
                                    </span>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <p v-if="upcomingAppointments.length === 0">You have no upcoming appointments.</p>
            </div>

            <div class="d-none d-md-block">
                <div class="table-responsive-sm">
                    <table class="table table-sm" v-if="upcomingAppointments.length > 0">
                        <colgroup>
                            <col width="40">
                            <col width="140">
                            <col width="140">
                            <col>
                            <col width="180">
                            <col width="250">
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Time</th>
                                <th scope="col">Status</th>
                                <th scope="col">Doctor Name</th>
                                <th scope="col">Medical Reports <br>Viewable by Doctor?</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(appointment, index) in upcomingAppointments" :key="index">
                                <td>{{index+1}}</td>
                                <td class="text-nowrap">{{appointment.startDate}}</td>
                                <td class="text-nowrap">{{appointment.startTime}}</td>
                                <td>
                                    <span class="badge text-nowrap" :class="getAppointmentStatusBadgeClass(appointment.status)">
                                        {{getAppointmentStatus(appointment.status)}}
                                    </span>
                                </td>
                                <td>{{appointment.targetUser}}</td>
                                <td>{{appointment.consentViewMedicalReport}}</td>
                                <td class="text-nowrap">
                                    <template v-if="appointment.status === 0">
                                        <a href="javascript:void(0);" @click="showCancelConfirmation(appointment.appointmentId)">Cancel Appointment</a>
                                    </template>
                                    <template v-else-if="appointment.status === 998">
                                        <router-link :to="{'name': 'user-doctor-appointment-detail', 'params': {'id': appointment.appointmentId}}">
                                            Pay Now
                                        </router-link>
                                        | <a href="javascript:void(0);" @click="showCancelConfirmation(appointment.appointmentId)">Cancel Appointment</a>
                                    </template>
                                    <template v-else-if="appointment.status === 1000">
                                        <a href="javascript:void(0);" @click="patientStartConsultation(appointment.sessionId)">Start Tele-Video</a>
                                        <template v-if="appointment.isWithin24Hours">
                                           <br/><a href="javascript:void(0);" @click="showCancelConfirmation(appointment.appointmentId)">Cancel Appointment</a>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <span class="font-italic">
                                        No Action
                                        </span>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p v-else>You have no upcoming appointments.</p>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="card mb-4">
        <div class="card-body">
            <h5 class="mb-3">Medicine Delivery</h5>
            <div class="d-md-none">
                <p v-if="consultationList.length === 0">
                       Your medicine delivery list is empty.
                </p>
                <div class="card mb-3" v-for="(consultation, index) in consultationList" :key="index">
                    <div class="card-body">
                        <div class="mb-3">
                            <label class="label-display">
                                Date Time
                            </label>
                            <div>
                                {{ consultation.dateTime }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Status
                            </label>
                            <div class="mt-2">
                                <span class="badge text-nowrap" :class="getMedicineChargesBadgeClass(consultation.status)">
                                    {{getMedicineChargesStatus(consultation.status)}}
                                </span>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Consultation ID
                            </label>
                            <div>
                                {{consultation.consultationIdShort}}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Doctor Name
                            </label>
                            <div>
                                {{consultation.doctorName}}
                            </div>
                        </div>
                        <div>
                            <label class="label-display">
                                Action
                            </label>
                            <div class="mt-2">
                                <router-link :to="{
                                    'name': 'user-consultation-medicine-delivery-detail',
                                    'params': {
                                        'id': consultation.consultationId
                                    }
                                }" class="btn btn-primary btn-primary-insv">
                                    {{ consultation.status === 1 ? 'Pay Now' : 'View Details'}}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-none d-md-block">
                <div class="table-responsive">
                     <p v-if="consultationList.length === 0">
                       Your medicine delivery list is empty.
                    </p>
                    <table v-else ref="listTable" class="table table-hover">
                        <colgroup>
                            <col width="40">
                            <col width="140">
                            <col width="140">
                            <col>
                            <col width="180">
                            <col width="250">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Date</th>
                                <th>Time</th>
                                <th>Status</th>
                                <th>Consultation ID</th>
                                <th>Doctor Name</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr v-for="(consultation, index) in consultationList" :key="index">
                                <th scope="row">{{index + 1}}</th>

                                <td class="text-nowrap">
                                    {{ consultation.date }}
                                </td>

                                <td class="text-nowrap">
                                    {{ consultation.time }}
                                </td>
                                <td>
                                    <span class="badge text-nowrap" :class="getMedicineChargesBadgeClass(consultation.status)">
                                        {{getMedicineChargesStatus(consultation.status)}}
                                    </span>
                                </td>
                                <td>{{consultation.consultationIdShort}}</td>
                                <td>{{consultation.doctorName}}</td>
                                <td class="text-nowrap">
                                    <router-link :to="{
                                    'name': 'user-consultation-medicine-delivery-detail',
                                    'params': {
                                        'id': consultation.consultationId
                                    }
                                }">
                                        {{ consultation.status === 1 ? 'Pay Now' : 'View Details'}}
                                    </router-link>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div> -->

    <div class="card mb-4">
        <div class="card-body">
            <h5 class="mb-3">Prescription Payments</h5>
            <div class="d-md-none">
                <p v-if="prescriptionPayments.length === 0">
                    You have no prescription payment records.
                </p>

                <div class="card mb-3" v-for="(prescription, index) in prescriptionPayments" :key="index">
                    <div class="card-body">
                        <div class="mb-3">
                            <label class="label-display">
                                Date
                            </label>
                            <div>
                                {{ prescription.prescriptionDate }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Prescription Id
                            </label>
                            <div>
                                {{ prescription.prescriptionCode }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Price
                            </label>
                            <div>
                                RM {{ prescription.price }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Payment Status
                            </label>
                            <div>
                                {{ prescription.paymentRequired ? 'Pending Payment' : 'Paid' }}
                            </div>
                        </div>
                        <div>
                            <label class="label-display">
                                Action
                            </label>
                            <div class="mt-2">
                                <router-link class="btn btn-primary btn-primary-insv"
                                    :to="{'name': 'user-prescription-detail', 'params': {'id': prescription.prescriptionId}}">
                                    {{ prescription.paymentRequired? 'Pay Now' : 'View Prescription' }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-none d-md-block">
                <div class="table-responsive-sm">
                    <table class="table table-sm" v-if="prescriptionPayments.length > 0">
                        <colgroup>
                            <col width="40">
                            <col width="140">
                            <col>
                            <col width="180">
                            <col width="180">
                            <col width="250">
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Prescription Id</th>
                                <th scope="col">Price</th>
                                <th scope="col">Payment Status</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(prescription, index) in prescriptionPayments" :key="index">
                                <td>{{index+1}}</td>
                                <td class="text-nowrap">{{prescription.prescriptionDate}}</td>
                                <td>{{prescription.prescriptionCode}}</td>
                                <td class="text-nowrap">{{prescription.price}}</td>
                                <td>{{prescription.paymentRequired? 'Pending Payment': 'Paid'}}</td>
                                <td class="text-nowrap"><router-link :to="{'name': 'user-prescription-detail', 'params': {'id': prescription.prescriptionId}}">{{prescription.paymentRequired? 'Pay Now': 'View Prescription'}}</router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p v-else>You have no prescription payment records.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="card mb-4">
        <div class="card-body">
            <h5 class="mb-3">Medicine Delivery Status</h5>

            <div class="d-md-none">
                <p v-if="prescriptionDeliveryStatus.length === 0">
                    You have not purchased any medicine yet.
                </p>

                <div class="card mb-3" v-for="(prescription, index) in prescriptionDeliveryStatus" :key="index">
                    <div class="card-body">
                        <div class="mb-3">
                            <label class="label-display">
                                Date
                            </label>
                            <div>
                                {{ prescription.prescriptionDate }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Prescription Id
                            </label>
                            <div>
                                {{ prescription.prescriptionCode }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Description
                            </label>
                            <div>
                                {{ prescription.description }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Status
                            </label>
                            <div>
                                {{ prescription.status }}
                            </div>
                        </div>
                        <div>
                            <label class="label-display">
                                Action
                            </label>
                            <div class="mt-2">
                                <router-link class="btn btn-primary btn-primary-insv" :to="{'name': 'user-prescription-detail', 'params': {'id': prescription.prescriptionId}}">
                                    {{prescription.paymentRequired? 'Pay Now': 'View Prescription'}}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-none d-md-block">
                <div class="table-responsive-sm">
                    <table class="table table-sm" v-if="prescriptionDeliveryStatus.length > 0">
                        <colgroup>
                            <col width="40">
                            <col width="140">
                            <col width="140">
                            <col>
                            <col width="180">
                            <col width="250">
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Prescription Id</th>
                                <th scope="col">Description</th>
                                <th scope="col">Status</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(prescription, index) in prescriptionDeliveryStatus" :key="index">
                                <td>{{index+1}}</td>
                                <td class="text-nowrap">{{prescription.prescriptionDate}}</td>
                                <td>{{prescription.prescriptionCode}}</td>
                                <td>{{prescription.description}}</td>
                                <td>{{prescription.status}}</td>
                                <td class="text-nowrap"><router-link :to="{'name': 'user-prescription-detail', 'params': {'id': prescription.prescriptionId}}">{{prescription.paymentRequired? 'Pay Now': 'View Prescription'}}</router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p v-else>You have not purchased any medicine yet.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="card mb-4">
        <div class="card-body">
            <h5 class="mb-3">Remaining Days of Prescriptions</h5>

            <div class="d-md-none">
                <p v-if="remainingDaysOfPrescriptions.length === 0">
                    You have not purchased any medicine yet.
                </p>

                <div class="card mb-3" v-for="(prescription, index) in remainingDaysOfPrescriptions" :key="index">
                    <div class="card-body">
                        <div class="mb-3">
                            <label class="label-display">
                                Date
                            </label>
                            <div>
                                {{ prescription.prescriptionDate }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Prescription Id
                            </label>
                            <div>
                                {{ prescription.prescriptionCode }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Description
                            </label>
                            <div>
                                {{ prescription.description }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Remaining Days
                            </label>
                            <div>
                                {{ prescription.remainingDays }}
                            </div>
                        </div>
                        <div>
                            <label class="label-display">
                                Action
                            </label>
                            <div class="mt-2">
                                <router-link class="btn btn-primary btn-primary-insv" :to="{'name': 'user-prescription-detail', 'params': {'id': prescription.prescriptionId}}">{{prescription.paymentRequired? 'Pay Now': 'View Prescription'}}</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-none d-md-block">
                <div class="table-responsive-sm">
                    <table class="table table-sm" v-if="remainingDaysOfPrescriptions.length > 0">
                        <colgroup>
                            <col width="40">
                            <col width="140">
                            <col width="140">
                            <col>
                            <col width="180">
                            <col width="250">
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Prescription Id</th>
                                <th scope="col">Description</th>
                                <th scope="col" class="text-right pr-5">Remaining Days</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(prescription, index) in remainingDaysOfPrescriptions" :key="index">
                                <td>{{index+1}}</td>
                                <td class="text-nowrap">{{prescription.prescriptionDate}}</td>
                                <td>{{prescription.prescriptionCode}}</td>
                                <td>{{prescription.description}}</td>
                                <td class="text-right pr-5">{{prescription.remainingDays}}</td>
                                <td class="text-nowrap"><router-link :to="{'name': 'user-prescription-detail', 'params': {'id': prescription.prescriptionId}}">{{prescription.paymentRequired? 'Pay Now': 'View Prescription'}}</router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p v-else>You have not purchased any medicine yet.</p>
                </div>
            </div>
        </div>
    </div>

    <popup-modal ref="popupModalConfirmation" :hasCloseButton="false" title="Cancel Appointment">
        <template slot="content">
            <p>{{ appointment.confirmationMessage }}</p>

            <template v-if="!isCancelling">
                <label>Reason</label>
                <input type="text" class="form-control" placeholder="Enter reason" v-model="cancelReason">
            </template>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-danger" @click="confirmCancelAppointment">Cancel Appointment</button>
            <button type="button" class="btn btn-secondary" @click="dismissCancelConfirmation">Cancel</button>
        </template>
    </popup-modal>

    <popup-modal ref="popupModalShowReschedule" :hasCloseButton="false" title="Appointment Cancelled">
            <template slot="content">
            <p>You doctor appointment has been successfully cancelled.</p>
            <p>Do you want to schedule a new appointment?</p>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-primary btn-primary-insv" @click="goToNewSchedule">Schedule New Appointment</button>
            <button type="button" class="btn btn-secondary" @click="dismissReschedule">No</button>
        </template>
    </popup-modal>
</div>
</template>

<script>
import {
    doctorConsultationNoPharmacyPrescriptionStatus,
    appointmentStatus,
    getEnumBadgeClass,
    getEnumDisplay
} from '@/config/enums';
import moment from 'moment';
import { convertToUserReadableDate, convertToUserReadableTime } from '@/utilities';
import datetimePicker from '@/components/datetime-picker';
import popupModal from '@/components/popup-modal';
export default {
    'name': 'UserDashboard',
    'components': {
        datetimePicker,
        popupModal
    },
    data () {
        return {
            'shouldRecursiveUpdate': true,
            'upcomingAppointments': [],
            'prescriptionPayments': [],
            'prescriptionDeliveryStatus': [],
            'remainingDaysOfPrescriptions': [],
            'paidConsultations': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'paidPrescriptions': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'consultationList': [],
            'appointment': {

                'toCancelId': null,
                'confirmationMessage': ''
            },
            'isCancelling': false,
            'cancelReason': null
        };
    },
    mounted () {
        this.getDashboard();
        this.getMedicineDeliveryList();

        this.recursiveUpdate();
    },
    beforeRouteLeave (to, from, next) {
        this.shouldRecursiveUpdate = false;
        next();
    },
    'methods': {
        recursiveUpdate () {
            if (this.shouldRecursiveUpdate) {
                setTimeout(() => {
                    this.getMedicineDeliveryList();
                    this.getUserDashboardUpcomingAppointments();
                    this.getUserDashboardPrescriptionPayment();
                    this.recursiveUpdate();
                }, 5000);
            }
        },
        getAppointmentStatus (statusId) {
            return getEnumDisplay(appointmentStatus, statusId);
        },
        getAppointmentStatusBadgeClass (statusId) {
            return getEnumBadgeClass(appointmentStatus, statusId);
        },
        getMedicineChargesStatus (statusId) {
            return getEnumDisplay(doctorConsultationNoPharmacyPrescriptionStatus, statusId);
        },
        getMedicineChargesBadgeClass (statusId) {
            return getEnumBadgeClass(doctorConsultationNoPharmacyPrescriptionStatus, statusId);
        },
        getDashboard () {
            this.axios.get('Dashboard/GetUserDashboard').then(({ data }) => {
                this.upcomingAppointments = data.data.ua ? data.data.ua.map((a) =>
                    ({
                        'startDate': a.ss ? convertToUserReadableDate(a.ss) : '-',
                        'startTime': a.ss ? convertToUserReadableTime(a.ss) : '-',
                        'status': a.si,
                        'appointmentId': a.ai,
                        'targetUser': a.tp ? a.tp.fn : '-',
                        'sessionId': a.sid,
                        'consentViewMedicalReport': a.cvmr ? 'Allowed' : 'Not Allowed',
                        'isWithin24Hours': a.ss ? moment.duration(moment(a.ss).diff(moment())).asDays() > 1 : false
                    })) : [];

                this.prescriptionPayments = data.data.pp ? data.data.pp.map((p) =>
                    ({
                        'prescriptionCode': p.plis,
                        'prescriptionId': p.pli,
                        'prescriptionDate': p.cd ? convertToUserReadableDate(p.cd) : '-',
                        'price': p.psr ? `RM ${p.psr.am.toFixed(2)}` : '-',
                        'paymentRequired': p.ps === 998,
                        'status': p.s,
                        'description': p.iu ? 'Uploaded Prescription List' : 'Consultation with Doctor'
                    })) : [];

                this.prescriptionDeliveryStatus = data.data.pd ? data.data.pd.map((p) =>
                    ({
                        'prescriptionCode': p.plis,
                        'prescriptionId': p.pli,
                        'prescriptionDate': p.cd ? convertToUserReadableDate(p.cd) : '-',
                        'price': p.psr ? `RM ${p.psr.am.toFixed(2)}` : '-',
                        'paymentRequired': p.ps === 998,
                        'status': p.s,
                        'description': p.iu ? 'Uploaded Prescription List' : 'Consultation with Doctor'
                    })) : [];

                this.remainingDaysOfPrescriptions = data.data.prd ? data.data.prd.map((p) =>
                    ({
                        'prescriptionCode': p.plis,
                        'prescriptionId': p.pli,
                        'prescriptionDate': p.cd ? convertToUserReadableDate(p.cd) : '-',
                        'price': p.psr ? `RM ${p.psr.am.toFixed(2)}` : '-',
                        'paymentRequired': p.ps === 998,
                        'status': p.s,
                        'description': p.iu ? 'Uploaded Prescription List' : 'Consultation with Doctor',
                        'remainingDays': p.prd >= 0 ? p.prd : 'Expired'
                    })) : [];

                if (data.data.tc) {
                    this.setVideoConsultation(data.data.tc);
                }

                if (data.data.tp) {
                    this.setPurchasedMedicine(data.data.tp);
                }
            });
        },
        setVideoConsultation (consultationCount) {
            this.paidConsultations.count = consultationCount.c;
            this.paidConsultations.startDate = moment(consultationCount.sd);
            this.paidConsultations.endDate = moment(consultationCount.ed);

            if (this.$refs.totalVideoConsultation) {
                this.$refs.totalVideoConsultation.setDate(this.paidConsultations.startDate, this.paidConsultations.endDate);
            }
        },
        setPurchasedMedicine (paidMedicineCount) {
            this.paidPrescriptions.count = paidMedicineCount.c;
            this.paidPrescriptions.startDate = moment(paidMedicineCount.sd);
            this.paidPrescriptions.endDate = moment(paidMedicineCount.ed);

            if (this.$refs.totalPurchasedMedicine) {
                this.$refs.totalPurchasedMedicine.setDate(this.paidPrescriptions.startDate, this.paidPrescriptions.endDate);
            }
        },
        viewTotalConsultations () {
            let { startDate, endDate } = this.$refs.totalVideoConsultation.getDates();
            this.axios.post('Dashboard/GetUserDashboardTotalVideoConsultation',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setVideoConsultation(data.data);
            });
        },
        viewTotalPurchasedMedicine () {
            let { startDate, endDate } = this.$refs.totalPurchasedMedicine.getDates();
            this.axios.post('Dashboard/GetUserDashboardTotalMedicinePayments',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setPurchasedMedicine(data.data);
            });
        },
        patientStartConsultation (consultationId) {
            this.axios.post('Consultation/PatientStartConsultation', null, {
                'params': {
                    'consultationId': consultationId
                }
            }).then(() => {
                this.$router.push({
                    'name': 'user-consultation-detail',
                    'params': {
                        'id': consultationId
                    }
                });
            }).catch(({
                response
            }) => {

            });
        },
        getMedicineDeliveryList () {
            this.axios.post('Consultation/GetPatientMedicineDelivery', {
                'p': 1,
                'ps': 5
            }).then(({
                data
            }) => {
                let pagedResult = data.data;

                let list = pagedResult.l;

                this.consultationList = list.map((consultation) => ({
                    'date': consultation.ca ? convertToUserReadableDate(consultation.ca) : '-',
                    'time': consultation.ca ? convertToUserReadableTime(consultation.ca) : '-',
                    'doctorName': consultation.dn,
                    'patientName': consultation.pn,
                    'status': consultation.s,
                    'consultationId': consultation.dc,
                    'consultationIdShort': consultation.dcis
                }));
            });
        },
        getUserDashboardUpcomingAppointments () {
            this.axios.get('Dashboard/GetUserDashboardUpcomingAppointments').then(({ data }) => {
                this.upcomingAppointments = data.data ? data.data.map((a) =>
                    ({
                        'startDate': a.ss ? convertToUserReadableDate(a.ss) : '-',
                        'startTime': a.ss ? convertToUserReadableTime(a.ss) : '-',
                        'status': a.si,
                        'appointmentId': a.ai,
                        'targetUser': a.tp ? a.tp.fn : '-',
                        'sessionId': a.sid,
                        'consentViewMedicalReport': a.cvmr ? 'Allowed' : 'Not Allowed',
                        'isWithin24Hours': a.ss ? moment.duration(moment(a.ss).diff(moment())).asDays() > 1 : false
                    })) : [];
            });
        },
        getUserDashboardPrescriptionPayment () {
            this.axios.get('Dashboard/GetUserDashboardPrescriptionPayment').then(({ data }) => {
                this.prescriptionPayments = data.data ? data.data.map((p) =>
                    ({
                        'prescriptionCode': p.plis,
                        'prescriptionId': p.pli,
                        'prescriptionDate': p.cd ? convertToUserReadableDate(p.cd) : '-',
                        'price': p.psr ? `RM ${p.psr.am.toFixed(2)}` : '-',
                        'paymentRequired': p.ps === 998,
                        'status': p.s,
                        'description': p.iu ? 'Uploaded Prescription List' : 'Consultation with Doctor'
                    })) : [];
            });
        },
        showCancelConfirmation (toCancelId) {
            this.isCancelling = false;
            this.cancelReason = null;
            this.appointment.toCancelId = toCancelId;

            this.appointment.confirmationMessage = 'Are you sure you want to cancel this appointment? This action cannot be undone.';
            this.$refs.popupModalConfirmation.show();
        },
        confirmCancelAppointment () {
            this.isCancelling = true;
            this.appointment.confirmationMessage = 'Cancelling appointment...';

            this.axios.post('Appointment/PatientCancelAppointment', null, {
                'params': {
                    'appointmentId': this.appointment.toCancelId,
                    'cancelReason': this.cancelReason
                }
            }).then(() => {
                this.dismissCancelConfirmation().then(() => {
                    this.$refs.popupModalShowReschedule.show();
                });
            }).catch(({
                response
            }) => {
                this.appointment.confirmationMessage = 'Error cancelling appontment. Please try again.';
            });
        },
        dismissCancelConfirmation (callback = null) {
            this.appointment.toCancelId = null;
            return this.$refs.popupModalConfirmation.hide();
        },
        goToNewSchedule () {
            this.$refs.popupModalShowReschedule.hide().then(() => {
                this.$router.push({ 'name': 'user-doctor-appointment-create' });
            });
        },
        dismissReschedule () {
            this.$refs.popupModalShowReschedule.hide();
        }
    }
};
</script>

<style>

</style>
